var _circle, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgUnapprovedUser = function SvgUnapprovedUser(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    fill: "none",
    viewBox: "0 0 73 72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.25,
    cy: 36,
    r: 35.5,
    fill: "#FF9A9A",
    stroke: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E02020",
    fillRule: "evenodd",
    d: "M51.347 35.674c0 8.518-6.905 15.423-15.423 15.423-8.519 0-15.424-6.905-15.424-15.423 0-8.519 6.905-15.424 15.424-15.424 8.518 0 15.423 6.905 15.423 15.424zm-9.705-3.537l-3.537 3.537 3.537 3.536c.603.603.603 1.579 0 2.181-.301.301-.696.452-1.09.452-.395 0-.79-.15-1.091-.452l-3.537-3.536-3.536 3.536c-.301.301-.696.452-1.09.452-.395 0-.79-.15-1.091-.452-.603-.602-.603-1.578 0-2.18l3.536-3.537-3.536-3.537c-.603-.602-.603-1.578 0-2.18.602-.603 1.578-.603 2.18 0l3.537 3.536 3.537-3.537c.602-.602 1.578-.602 2.18 0 .603.603.603 1.579 0 2.181z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnapprovedUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unapproved-user.378ef9e6.svg";
export { ForwardRef as ReactComponent };